const DB_NAME = 'gpt-debate-cache';
const DB_VERSION = 1;
const DEBATE_STORE = 'debates';

class IndexedDBService {
  constructor() {
    this.db = null;
  }

  async init() {
    if (this.db) return;

    return new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        this.db = request.result;
        resolve(this.db);
      };

      request.onupgradeneeded = (event) => {
        const db = event.target.result;
        if (!db.objectStoreNames.contains(DEBATE_STORE)) {
          const store = db.createObjectStore(DEBATE_STORE, { keyPath: 'id' });
          store.createIndex('userId', 'userId', { unique: false });
          store.createIndex('status', 'status', { unique: false });
        }
      };
    });
  }

  async getDebate(debateId) {
    await this.init();
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([DEBATE_STORE], 'readonly');
      const store = transaction.objectStore(DEBATE_STORE);
      const request = store.get(debateId);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve(request.result);
    });
  }

  async cacheDebate(debate, debateId) {
    if (!debate || !debateId) {
      throw new Error('Both debate data and debateId are required');
    }

    await this.init();
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([DEBATE_STORE], 'readwrite');
      const store = transaction.objectStore(DEBATE_STORE);
      // Ensure the ID is included in the stored data
      const debateWithId = {
        ...debate,
        id: debateId
      };
      const request = store.put(debateWithId);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => resolve();
    });
  }

  async clearCache(userId) {
    await this.init();
    return new Promise((resolve, reject) => {
      const transaction = this.db.transaction([DEBATE_STORE], 'readwrite');
      const store = transaction.objectStore(DEBATE_STORE);
      const index = store.index('userId');
      const request = index.getAllKeys(userId);

      request.onerror = () => reject(request.error);
      request.onsuccess = () => {
        const keys = request.result;
        const deletePromises = keys.map((key) => 
          new Promise((resolveDelete, rejectDelete) => {
            const deleteRequest = store.delete(key);
            deleteRequest.onerror = () => rejectDelete(deleteRequest.error);
            deleteRequest.onsuccess = () => resolveDelete(undefined);
          })
        );

        Promise.all(deletePromises)
          .then(() => resolve())
          .catch(reject);
      };
    });
  }
}

export const indexedDBService = new IndexedDBService();